import React, { useContext } from 'react';
import { useBankAccount, useIdentityValidation } from 'commons/hooks';
import IdentityValidationRoutes from './NewIdentityValidation/IdentityValidationRoutes';
import { DocumentsContext } from './DocumentsContext';
import IdentityValidationError from './IdentityValidationError';
import IdentityValidationSkeleton from './IdentityValidationSkeleton';

function IdentityValidation(): JSX.Element {
  const documents = useContext(DocumentsContext);
  const bankAccount = useBankAccount();
  const identityValidation = useIdentityValidation();
  const isLoading =
    bankAccount.isLoading ||
    documents.loading ||
    bankAccount.error ||
    identityValidation.isLoading;

  if (isLoading) return <IdentityValidationSkeleton />;
  if (identityValidation.isError) return <IdentityValidationError />;

  return <IdentityValidationRoutes />;
}

IdentityValidation.Skeleton = IdentityValidationSkeleton;
export default IdentityValidation;
